'use client'

import { motion } from 'motion/react'
import { Zap } from 'lucide-react'

export function Footer() {
  return (
    <motion.footer
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="relative py-12 px-6"
      style={{ background: '#08080e' }}
    >
      <div
        className="absolute top-0 left-6 right-6 h-px"
        style={{
          background:
            'linear-gradient(90deg, transparent, rgba(0,234,255,0.12), transparent)',
        }}
      />

      <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        {/* Logo */}
        <div className="flex items-center gap-3">
          <div
            className="w-8 h-8 rounded-lg flex items-center justify-center"
            style={{ background: 'linear-gradient(135deg, #00eaff, #0077ff)' }}
          >
            <Zap size={14} fill="#08080e" color="#08080e" />
          </div>
          <span
            style={{
              fontFamily: "'Russo One', sans-serif",
              color: '#fff',
              fontSize: '15px',
            }}
          >
            MK8D<span style={{ color: '#00eaff' }}>·</span>STATS
          </span>
        </div>

        <p
          style={{
            fontFamily: "'Barlow Condensed', sans-serif",
            fontSize: '12px',
            color: 'rgba(255,255,255,0.2)',
            letterSpacing: '0.08em',
            textAlign: 'center',
          }}
        >
          NOT AFFILIATED WITH NINTENDO · FOR RYUJINX EMULATOR USE ONLY
        </p>

        <div />
      </div>
    </motion.footer>
  )
}
